import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DeviceService} from '../../shared/device/device.service';

@Component({
    selector: 'insight-summary',
    templateUrl: './insight-summary.component.html',
    styleUrls: ['./insight-summary.component.css']
})
export class InsightSummaryComponent implements OnInit {

    @Input() timePeriod: String;
    @Output() onClick: EventEmitter<any>;

    data = [];
    loading: boolean;

    constructor(private deviceService: DeviceService) {
        this.loading = true;
        this.timePeriod = 'w';  // default timePeriod is weekly
        this.onClick = new EventEmitter();
        console.log('qqq loading in constructor = ', this.loading);
    }

    ngOnInit() {
        const self = this;
        this.deviceService.getDeviceSummary({timePeriod: this.timePeriod, deviceType: ''}).subscribe(function(summary){
            self.data = summary;
            console.log('qqq summary = ', summary);
            if (summary.length > 0) {
                self.loading = false;
                console.log('qqq loading after data received = ', self.loading);
            }
        });
    }

    ngOnChanges(changes) {
        console.log('changes in insight-summary component = ', changes);
        if ('timePeriod' in changes) {
            if (typeof changes.timePeriod !== undefined) {
                this.timePeriod = changes.timePeriod.currentValue;
            }
        }
    }

    onInsightClick(evt) {
        // console.log(evt.type);
        this.onClick.emit(evt.type);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/insight-summary/insight-summary.component.ts